import React from 'react'
import firebase from 'firebase'
import { firebaseApp } from '../../base'

const authenticate = provider => {
  const authProvider = new firebase.auth[`${provider}AuthProvider`]()
  firebaseApp
    .auth()
    .signInWithPopup(authProvider)
}

const Login = () => (
  <div className='content'>
    <h1>Login</h1>
    <div className='login'>
      <button className='button login--google'>Google</button>
      <button
        className='button login--facebook'
        onClick={() => {
          authenticate('Facebook')
        }}
      >
        Facebook
      </button>
    </div>
  </div>
)

export default Login



// WEBPACK FOOTER //
// ./src/components/AppAuth/Login.js